function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

function extractDomain(url) {
  var domain;
  if (url.startsWith('//')){
     url = url.replace('//','');
    console.log("domain : ",domain)
  }
  
  //find & remove protocol (http, ftp, etc.) and get domain
  if (url.indexOf("://") > -1) {
    domain = url.split('/')[2];
  }
  else {
    domain = url.split('/')[0];
  }
  
  //find & remove www
  if (domain.indexOf("www.") > -1) { 
    domain = domain.split('www.')[1];
  }
  
  domain = domain.split(':')[0]; //find & remove port number
  domain = domain.split('?')[0]; //find & remove url params

  return domain;
}

function fixDomain(m){
  let r = extractDomain(m);
  let r2 = replaceAll(r,'.myshopify.com','');
  return r2
}

function alpineInstance() {
    return {
        open: false,
        selectedFeature: false,
        modalTitle: 'Ultimate Search Demo Guide',
        title: 'Demo Walkthrough',
        description: 'Discover how Ultimate Search works and optimises your ecommerce site',
        showModal: false,
        domain: '',
        features: [{
                id: "smart-search",
                title: "Smart Site Search",
                headerTitle: "AI-powered Site search enhances your Product discovery",
                selectedValues: [],
                options: [{
                        id: "73cb76e7-e7e6-4d03-b514-f59b6ff18eec",
                        title: "Natural language processing and Variant Search",
                        description: "Search for <b>“blue shirt”</b>. Our app will look for the matching variant, even if the main variant is red.",
                    },
                    {
                        id: "fcd6f99a-d37e-4aac-b214-5d3b5e09fa5c",
                        title: "Typo tolerance",
                        description: "Search for <b>“traner”</b>. Our app will show users the results based on the correct spelling <b>“trainers”</b>.",
                    },
                    {
                        id: "4a378019-02c4-4968-b0f5-8ea8f25a3d23",
                        title: "Autocomplete suggestions & Product match",
                        description: "Type <b>“cot”</b> in the search box. Our app will provide relevant suggestions.",
                    },
                    {
                        id: "a3499bac-1ffc-416f-9ec0-91a7da4cde16",
                        title: "Synonym search",
                        description: 'Search for <b>“sneakers”</b>. Our Synonym tool allows you to define equivalent terms, such as <b>“trainers, sneakers, running shoes”</b> to expand the scope of a search query.',
                    },
                    {
                        id: "a3499bac-1ffc-416f-9ec0-91a7da4cde25",
                        title: "Search merchandising",
                        description: 'Search for <b>“dress”</b>. You can promote Sale products on top of the results.',
                    },
                    {
                        id: "94336811-193c-44db-8c1a-65cbf8a54442",
                        title: "Page redirect",
                        description: 'Search for <b>“gift for him”</b>. It will automatically send the user the Men collection page.',
                    },
                ],
            },
            {
                id: "product-filters",
                title: "Product filters",
                headerTitle: "Smart product filtering builds effective navigation",
                selectedValues: [],
                options: [{
                        id: "acfe9577-0945-4a34-9b81-6369074cddb2",
                        title: "Product filter on Collection and Search result page",
                        description: "Search for <b>“shirt”</b>. Product filters based on tag, option, vendor, etc. help users narrow down their selection.",
                    },
                    {
                        id: "35749874-c9a8-40cc-b908-4afd1f64962c",
                        title: "Multi-select filters",
                        description: "<a href='https://usf-vertical.myshopify.com/collections/dresses?uff_jlytq4_tags=%20Maxi_usf_%20Mini' target='_blank'>Select multiple dress length filters at the same time, for example <b>“Maxi”, “Mini”</b></a>"
                    },
                    {
                        id: "b61a2263-e028-42de-a93f-891acc3c714d",
                        title: "Show the matching variant with selected filter",
                        description: "<a href='https://usf-vertical.myshopify.com/collections/men-shirts?uff_6l3wgg_option%3AColor=Red' target='_blank'>Select <b>“Red”</b> in Color filter. It will show the matching variant even if the main variant is blue.</a>"
                    },
                    {
                        id: "a200ca50-eeac-427a-a9aa-2a3c0283fe3a",
                        title: "Merge values",
                        description: "<a href='https://usf-vertical.myshopify.com/collections/men-shirts?uff_6l3wgg_option%3AColor=Blue' target='_blank'>Select <b>“Blue”</b> in Color filter. Our Merge value tool allows you to combine “Ice Flow”, “Atlantic Blue”, “Navy” into “Blue”  </a>"
                    },
                    {
                        id: "a555e96e-b58a-4ac0-92e3-dbec63b4fbcf",
                        title: "Different filter menus for different collections",
                        description: "You can use different filters for each collection set.",
                    },
                ],
            },
        ],

        get selectedFeatureObject() {
            let selectedFeature = this.selectedFeature;
            for (let i = 0; i < this.features.length; i++) {
                if (this.features[i].id === selectedFeature) {
                    return this.features[i]
                }
            }
            return false

        },

        submitData() {
            let domain = this.domain;
            let updatedDomain = fixDomain(domain);
            window.location.href = `https://usf.sobooster.com/usf-api/v1/shopify-handlers/init?shop=${updatedDomain}.myshopify.com`;
        }
    };
}